class VariantPickerSteps {
    constructor(container) {
        if (!container) return;
        this.container = container;
        this.currentStep = 0;

        // Define default option map immediately
        this.optionMap = {
            size: 'option1',
            type: 'option2',
            color: 'option3'
        };

        this.bundleItems = JSON.parse(localStorage.getItem('couchBundleItems')) || [];

        // Static image mapping for types (User to update paths)
        this.typeImages = {
            'Seat Cushion': 'https://cdn.shopify.com/s/files/1/0471/7078/1350/files/seat_cover_icon_be0b408b-c8fe-4a58-adab-68e9cc4e02a6.jpg?v=1765779254',
            'Back Cushion': 'https://cdn.shopify.com/s/files/1/0471/7078/1350/files/back_cover.jpg?v=1765779138',
            'Chaise Cushion': 'https://cdn.shopify.com/s/files/1/0471/7078/1350/files/image-chaise-cushion.png?v=1769832402',
            'Pillow Case': 'https://cdn.shopify.com/s/files/1/0471/7078/1350/files/pillow_case_icon_3b1a52e3-3249-4900-b044-15047d191cab.jpg?v=1765778840',
            'Custom Request': 'https://cdn.shopify.com/s/files/1/0471/7078/1350/files/pillow_case_icon_3b1a52e3-3249-4900-b044-15047d191cab.jpg?v=1765778840'
        };

        // Data from Liquid
        try {
            const variantDataEl = document.getElementById('variant-data');
            const optionsDataEl = document.getElementById('product-options');

            if (variantDataEl) {
                this.variants = JSON.parse(variantDataEl.textContent);
            } else {
                console.warn('Variant data element not found');
                this.variants = [];
            }

            if (optionsDataEl) {
                this.options = JSON.parse(optionsDataEl.textContent);
            }
        } catch (e) {
            console.error('Error parsing variant data', e);
            this.variants = [];
        }

        // State for current selection
        this.currentSelection = {
            length: 0,
            width: 0,
            height: 0,
            type: '',
            color: '', // e.g. "Charcoal Grey"
            quantity: 1
        };

        this.editingIndex = null; // Track editing state
        this.mapOptions();

        this.init();
    }

    mapOptions() {
        // Dynamic mapping based on this.options array provided by Liquid
        if (this.options && Array.isArray(this.options)) {
            // Using for...of loop to prevent any possible callback scope issues
            for (let index = 0; index < this.options.length; index++) {
                const opt = this.options[index];
                if (!opt || !opt.name) continue;

                const name = opt.name.toLowerCase();
                const key = `option${index + 1}`;

                // Ensure optionMap exists
                if (!this.optionMap) this.optionMap = {};

                if (name.includes('color')) this.optionMap.color = key;
                else if (name.includes('type') || name.includes('model')) this.optionMap.type = key;
                else if (name.includes('size') || name.includes('dimension')) this.optionMap.size = key;
            }
        }

        // Initial defaults
        const allColors = this.getUniqueOptionValues(this.optionMap.color);
        if (allColors.length) this.currentSelection.color = allColors[0];

        const allTypes = this.getUniqueOptionValues(this.optionMap.type);
        if (allTypes.length) this.currentSelection.type = allTypes[0];
    }

    init() {
        this.cacheElements();
        this.bindEvents();

        // Initial defaults (from DOM)
        if (this.typeSelect && this.typeSelect.options.length > 1) {
            // If currently select is empty/placeholder, try to pick first valid
            if (!this.typeSelect.value) {
                this.typeSelect.selectedIndex = 1;
            }
            this.currentSelection.type = this.typeSelect.value;
        }

        // Initialize color selection from DOM logic if needed
        if (this.colorGrid) {
            const checked = this.colorGrid.querySelector('input[type="radio"]:checked');
            if (checked) {
                this.currentSelection.color = checked.value;
            } else {
                const first = this.colorGrid.querySelector('input[type="radio"]');
                if (first) {
                    first.checked = true;
                    this.currentSelection.color = first.value;
                }
            }
        }

        this.updateColorPreview();
        this.updateQuantity();

        this.renderBundleList(); // Always call this to set initial visibility state
    }

    cacheElements() {
        this.steps = this.container.querySelectorAll('.step-content');
        this.qtyInput = this.container.querySelector('#cushion-qty');
        this.typeSelect = this.container.querySelector('#cushion-type-selector');
        this.colorGrid = this.container.querySelector('#color-grid-container');
        this.bundleContainer = this.container.querySelector('#persistent-bundle-container');
    }

    bindEvents() {
        // Step Navigation
        this.container.querySelectorAll('[data-action="next-step"]').forEach(btn => {
            btn.addEventListener('click', () => this.nextStep());
        });

        this.container.querySelectorAll('[data-action="prev-step"]').forEach(btn => {
            btn.addEventListener('click', () => this.prevStep());
        });

        this.container.querySelector('[data-action="open-color-picker"]').addEventListener('click', () => {
            this.goToStep(4);
        });

        this.container.querySelector('[data-action="confirm-color"]').addEventListener('click', () => {
            this.goToStep(2);
        });

        // Next to Step 3 (from Step 2 Header)
        // Next to Step 3 (from Step 2 Header) - using event delegation for robustness
        this.container.addEventListener('click', (e) => {
            const nextBtn = e.target.closest('[data-action="next-step-3"]');
            if (nextBtn) {
                console.log("Next Button Clicked - going to Step 3");
                this.goToStep(3);
            }
        });

        // Quantity
        this.container.querySelector('[data-action="increase-qty"]').addEventListener('click', () => {
            this.currentSelection.quantity++;
            this.updateQuantity();
        });

        this.container.querySelector('[data-action="decrease-qty"]').addEventListener('click', () => {
            if (this.currentSelection.quantity > 1) {
                this.currentSelection.quantity--;
                this.updateQuantity();
            }
        });

        // Add Cushion logic
        this.container.querySelector('[data-action="add-cushion"]').addEventListener('click', () => this.addCushionToBundle());

        // Add Another
        // Add Another (Event Delegation for multiple buttons)
        this.container.addEventListener('click', (e) => {
            if (e.target.matches('[data-action="add-another"]')) {
                this.goToStep(2);
                // User Request: "Remove the all scroll when we do any action"
                // const step2 = this.container.querySelector('[data-step="2"]');
                // if (step2) step2.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });


        // Helper Debounce
        const debounce = (func, wait) => {
            let timeout;
            return function (...args) {
                const context = this;
                clearTimeout(timeout);
                timeout = setTimeout(() => func.apply(context, args), wait);
            };
        };

        const debouncedHandleChange = debounce((e) => this.handleDimensionChange(e), 300);

        // Inputs
        this.container.querySelectorAll('#dim-length, #dim-width, #dim-height').forEach(input => {
            // User Request: "Let's detect them in small delay, like 300 ms"
            input.addEventListener('input', debouncedHandleChange);
        });

        if (this.typeSelect) {
            this.typeSelect.addEventListener('change', (e) => {
                this.currentSelection.type = e.target.value;
            });
        }

        // Color Grid Interactions (Radio Context)
        if (this.colorGrid) {
            this.colorGrid.addEventListener('change', (e) => {
                if (e.target.matches('input[name="cushion_color"]')) {
                    this.currentSelection.color = e.target.value;
                    const tempName = this.container.querySelector('#temp-selected-color-name');
                    if (tempName) tempName.textContent = e.target.value;
                    this.updateColorPreview();
                }
            });
        }

        // Checkout
        this.container.querySelector('[data-action="add-bundle-to-cart"]').addEventListener('click', () => this.addBundleToCart());

        // Bundle List Interactions
        const bundleContainer = this.container.querySelector('#bundle-items-container');
        if (bundleContainer) {
            bundleContainer.addEventListener('click', (e) => {
                if (e.target.classList.contains('btn-remove-item')) {
                    const idx = parseInt(e.target.dataset.index);
                    this.removeBundleItem(idx);
                }
                if (e.target.classList.contains('btn-edit-item')) {
                    const idx = parseInt(e.target.dataset.index);
                    this.editBundleItem(idx);
                }
            });
        }

        // Video Guide Popup
        const videoBtn = this.container.querySelector('[data-action="open-video-guide"]');
        if (videoBtn) {
            videoBtn.addEventListener('click', () => this.openVideoModal());
        }

        const modal = document.querySelector('#variant-video-modal');
        if (modal) {
            // Event Delegation for Modal Actions (Next, Back, Close)
            modal.addEventListener('click', (e) => {
                // Close Logic (Overlay click or X button or Custom Close Button)
                if (e.target === modal || e.target.closest('.video-modal-close-trigger')) {
                    this.closeVideoModal();
                    return;
                }

                // Next Slide
                const nextBtn = e.target.closest('.btn-guide-next');
                if (nextBtn) {
                    const target = nextBtn.dataset.target;
                    this.switchVideoSlide(target);
                }

                // Back Slide
                const backBtn = e.target.closest('.btn-guide-back');
                if (backBtn) {
                    const target = backBtn.dataset.target;
                    if (target) {
                        this.switchVideoSlide(target);
                    } else {
                        // Fallback if no target (e.g. Slide 1 back button acts as close)
                        this.closeVideoModal();
                    }
                }
            });
        }

        // Sync with Default Variant Picker (External)
        const externalVariantSelects = document.querySelector('variant-selects');
        if (externalVariantSelects) {
            externalVariantSelects.addEventListener('change', (e) => {
                let isColor = false;
                let value = e.target.value;

                // Check Fieldset data-option-name
                const fieldset = e.target.closest('fieldset');
                if (fieldset && fieldset.dataset.optionName === 'color') {
                    isColor = true;
                }

                // Check Dropdown/Container data-option-name
                const container = e.target.closest('[data-option-name]');
                if (container && container.dataset.optionName === 'color') {
                    isColor = true;
                }

                if (isColor) {
                    this.syncColorFromDefault(value);
                }
            });
        }

        // Robust Document Listener for Re-rendered Elements
        document.addEventListener('change', (e) => {
            const variantSelects = e.target.closest('variant-selects');
            if (!variantSelects) return;

            let isColor = false;
            let value = e.target.value;

            const fieldset = e.target.closest('fieldset');
            if (fieldset && fieldset.dataset.optionName === 'color') isColor = true;

            const container = e.target.closest('[data-option-name]');
            if (container && container.dataset.optionName === 'color') isColor = true;

            if (!isColor && e.target.name && e.target.name.toLowerCase().includes('color')) isColor = true;

            if (isColor) {
                this.syncColorFromDefault(value);
            }
        });
    }

    openVideoModal() {
        const modal = document.querySelector('#variant-video-modal');
        if (modal) {
            modal.style.display = 'block';
            document.body.style.overflow = 'hidden'; // Prevent background scrolling

            // Reset to Slide 1
            this.switchVideoSlide(1);
        }
    }

    closeVideoModal() {
        const modal = document.querySelector('#variant-video-modal');
        if (modal) {
            modal.style.display = 'none';
            document.body.style.overflow = ''; // Restore scrolling

            // Pause all videos
            const videos = modal.querySelectorAll('video');
            videos.forEach(v => {
                v.pause();
                v.currentTime = 0;
            });
        }
    }

    switchVideoSlide(slideIndex) {
        const modal = document.querySelector('#variant-video-modal');
        if (!modal) return;

        // Hide all slides
        modal.querySelectorAll('.guide-slide').forEach(el => {
            el.classList.add('hidden');
            el.classList.remove('active');
        });

        // Show target slide
        const targetSlide = modal.querySelector(`.guide-slide[data-slide="${slideIndex}"]`);
        if (targetSlide) {
            targetSlide.classList.remove('hidden');
            targetSlide.classList.add('active');
        }
    }

    syncColorFromDefault(colorValue) {
        // Update valid color state
        this.currentSelection.color = colorValue;

        // Update Custom UI (Step 3 radio)
        const radio = this.container.querySelector(`input[name="cushion_color"][value="${colorValue}"]`);
        if (radio) {
            radio.checked = true;
        } else {
            // Try fuzzy matching or finding by other attributes if standard value fail?
            // Should be exact match typically.
        }

        // Update Preview Text in Step 3
        const tempName = this.container.querySelector('#temp-selected-color-name');
        if (tempName) tempName.textContent = colorValue;

        // Update Preview Swatch/Text in Step 1/2
        this.updateColorPreview();

        // Re-run detection (variant might change if we filtered by color in finding logic)
        this.detectAndDisplayType();
    }



    goToStep(index) {
        this.steps.forEach(step => {
            step.classList.add('hidden');
        });

        const target = this.container.querySelector(`[data-step="${index}"]`);
        if (target) {
            target.classList.remove('hidden');
        }
        this.currentStep = index;

        // User Request: "Just don't let user know about the card moving, just focus on the middle of the screen."
        this.scrollToCard();
    }

    scrollToCard() {
        // Center the card in the viewport INSTANTLY (no smooth scroll)
        const card = this.container.querySelector('.variant-picker-card');
        if (card) {
            card.scrollIntoView({ behavior: 'auto', block: 'center' });
        } else {
            // Fallback to container if card not found
            this.container.scrollIntoView({ behavior: 'auto', block: 'center' });
        }
    }

    nextStep() {
        if (this.currentStep === 2) {
            // Validate before adding? Actually Step 2 adds to bundle via separate button
        }
        this.goToStep(this.currentStep + 1);
    }

    prevStep() {
        if (this.currentStep === 4) {
            // User Request: "Select color 'Back' should go to step 2"
            // Step 4 is Color Picker, Step 2 is Sizing Form
            this.goToStep(2);
            return;
        }
        this.goToStep(this.currentStep - 1);
    }

    getUniqueOptionValues(optionKey) {
        // extract e.g. all 'option1' values unique
        const values = new Set();
        this.variants.forEach(v => {
            if (v.options && v[optionKey]) values.add(v[optionKey]);
            // check 'options' array vs 'option1' key property on variant object
            // Shopify JS variants usually have .option1, .option2, etc.
        });
        // Check standard options array if variant property lookup failed (sometimes liquid output varies)
        if (values.size === 0) {
            const idx = parseInt(optionKey.replace('option', '')) - 1;
            this.variants.forEach(v => {
                if (v.options[idx]) values.add(v.options[idx]);
            });
        }
        return Array.from(values);
    }

    // renderTypes and populateColorGrid removed (Liquid handled)

    updateQuantity() {
        this.qtyInput.value = this.currentSelection.quantity;
    }

    updateColorPreview() {
        const nameEl = this.container.querySelector('.color-name');
        const swatchEl = this.container.querySelector('.selected-color-preview input[type="radio"]');
        nameEl.textContent = this.currentSelection.color || 'None Selected';

        // Mock visuals
        const color_handle = this.handleize(this.currentSelection.color);

        swatchEl.dataset.optionValue = color_handle;
    }
    handleize(str) {
        return String(str)
            .trim()                                 // remove leading/trailing spaces
            .toLowerCase()                          // lowercase
            .normalize('NFKD')                      // split accented chars (e.g. é -> e +  ́)
            .replace(/[\u0300-\u036f]/g, '')        // remove diacritics
            .replace(/[^a-z0-9]+/g, '-')            // replace groups of non-alphanumerics with hyphen
            .replace(/^-+|-+$/g, '');               // remove leading/trailing hyphens
    }

    handleDimensionChange(e) {
        let val = parseFloat(e.target.value);

        switch (e.target.id) {
            case 'dim-length': this.currentSelection.length = val; break;
            case 'dim-width': this.currentSelection.width = val; break;
            case 'dim-height': this.currentSelection.height = val; break;
        }

        // Trigger Auto-Detection
        this.detectAndDisplayType();
    }

    detectAndDisplayType() {
        const { length, width, height, color } = this.currentSelection;
        const addBtn = this.container.querySelector('[data-action="add-cushion"]');

        // Need 3 dims to detect properly
        if (!length || !width || !height) {
            if (addBtn) addBtn.disabled = true; // Disable if missing dims
            return;
        }

        const variant = this.findBestVariant(length, width, height, color);
        const displayEl = this.container.querySelector('#detected-type-display');

        if (displayEl) {
            if (variant) {
                // Determine Type from variant options (assuming mapping or heuristics)
                let typeName = 'Unknown';
                let sizeName = '';

                // Use optionMap if available to extract Type
                if (this.optionMap && this.optionMap.type) {
                    const idx = parseInt(this.optionMap.type.replace('option', '')) - 1;
                    typeName = variant.options[idx];
                }

                if (this.optionMap && this.optionMap.size) {
                    const idx = parseInt(this.optionMap.size.replace('option', '')) - 1;
                    sizeName = variant.options[idx];
                }

                // User Request: Rolled back to showing detection result
                // User Request: "Blank span for showing error message. otherwise, it'll hide all the time."

                // User Request: "Don't show any message to the Step 2"
                displayEl.style.display = 'none'; // Success -> Hide
                displayEl.textContent = '';

                // Update state
                this.currentSelection.type = typeName;
                if (addBtn) addBtn.disabled = false; // Enable on Success
            } else {
                // User Request: "If Data out of range, instead of showing error message we can collect that data"
                // CUSTOM ITEM DETECTED

                // User Request: "Don't show any message to the Step 2"
                displayEl.style.display = 'none'; // HIDDEN
                // displayEl.textContent = "Custom Size (Available for Request)";
                // displayEl.style.color = '#ff9800'; // Orange/Warning color for custom
                // displayEl.style.display = 'block';

                this.currentSelection.type = 'Custom Request';

                // Enable button for Custom Request
                if (addBtn) {
                    addBtn.disabled = false;
                    // User Request: "Don't update the Add Cushion button text"
                    // addBtn.textContent = 'Add Custom Request';
                }
            }
        }
    }

    findBestVariant(length, width, height, color) {
        // User Request: "Length is always higher than the Width... consider this as length"

        // Strictly parse as numbers to avoid string comparison issues (e.g. "66" > "35" is true, but safer to be explicit)
        let nLength = parseFloat(length);
        let nWidth = parseFloat(width);

        // Swap if Width > Length
        let searchLength = nLength;
        let searchWidth = nWidth;

        if (nWidth > nLength) {
            console.log(`[VariantPicker] Swapping Dims: ${nWidth} > ${nLength}`);
            searchLength = nWidth;
            searchWidth = nLength;
        } else {
            console.log(`[VariantPicker] No Swap: ${nWidth} <= ${nLength}`);
        }
        console.log(`[VariantPicker] Searching for Length: ${searchLength}, Width: ${searchWidth}`);

        // Search ALL variants matching the selected color (ignore Type input as it's auto-detected)

        const candidates = this.variants.filter(v => {
            const opts = v.options.map(o => o.toLowerCase());
            // Only check color match
            return opts.some(o => o === color.toLowerCase());
        });
        if (candidates.length === 0) return null;

        // 1. Sort Candidates by min_length ASCENDING initially
        // This ensures proper iteration order (Smallest -> Largest) and fallback behavior
        candidates.sort((a, b) => {
            return (a.metafields.min_length || 0) - (b.metafields.min_length || 0);
        });

        // 2. Primary Priority: LENGTH MATCH
        // Filter for variants where length is strictly within range
        const lengthMatches = candidates.filter(v => {
            const m = v.metafields;
            return searchLength >= m.min_length && searchLength <= m.max_length;
        });

        if (lengthMatches.length > 0) {
            // A. Secondary Priority: WIDTH (within the length-matched group)
            const widthMatches = lengthMatches.filter(v => {
                const m = v.metafields;
                return searchWidth >= m.min_width && searchWidth <= m.max_width;
            });

            if (widthMatches.length > 0) {
                // B. Tertiary Priority: HEIGHT (within the width-matched group)
                const heightMatches = widthMatches.filter(v => {
                    const m = v.metafields;
                    return height >= m.min_height && height <= m.max_height;
                });

                // Return best match: Height > Width > Length
                if (heightMatches.length > 0) return heightMatches[0];
                return widthMatches[0];
            } else {
                // User Request: "When Length greater than width and Length in range, then width should be in range too"
                // Strict check fail: Length matched but Width didn't -> Custom Size
                return null;
            }
        }

        // 3. Strict Range Check Only - No Fallback
        // If we haven't found a match in the logic above (which checks Length, then Width/Height),
        // it means the input dimensions are strictly out of the defined min/max ranges.

        // User Request: "when it's out of range (Min/Max), it'll show Size not available!"

        // So we return null here.
        return null;
    }

    addCushionToBundle() {
        const { length, width, height, type, color, quantity } = this.currentSelection;

        // Determine variant
        // Determine variant
        let variant = this.findBestVariant(length, width, height, color);

        // Custom Item Logic
        let isCustom = false;
        let itemTitle = variant ? variant.title : `${length}×${width}×${height}" Cushion`;
        // User Request: "propose price $40 per item" for custom
        let itemPrice = variant ? variant.price : 4000;
        let itemComparePrice = (variant && variant.compare_at_price) ? variant.compare_at_price : null; // Added compare price
        let itemId = variant ? variant.id : null;
        let itemSku = variant ? variant.sku : "";

        if (!variant) {
            // Check if we are in "Custom Request" mode (dimensions exist)
            if (length && width && height) {
                isCustom = true;
                itemTitle = "Custom Size Request";

                // User Request: "we'll add real variant called 'Custom Cushion'... always pick the (L) size"
                // Search for the specific REAL custom variant
                const customVariantCandidate = this.variants.find(v => {
                    const opts = v.options.map(o => o.toLowerCase());
                    const typeMatch = opts.some(o => o.includes('custom cushion') || o.includes('custom request'));
                    const sizeMatch = opts.some(o => o === 'l' || o === '(l)' || o === 'large');
                    // Also strictly match the color
                    const colorMatch = opts.some(o => o === color.toLowerCase());

                    return typeMatch && sizeMatch && colorMatch;
                });

                if (customVariantCandidate) {
                    console.log("Found Real Custom Variant:", customVariantCandidate);
                    variant = customVariantCandidate; // Use this variant!
                    itemId = customVariantCandidate.id;
                    itemPrice = customVariantCandidate.price;
                    itemComparePrice = customVariantCandidate.compare_at_price;
                    itemSku = customVariantCandidate.sku;
                    itemTitle = customVariantCandidate.title; // e.g. "Custom Cushion / (L) / Red"
                } else {
                    console.warn("Could not find real 'Custom Cushion' variant for color:", color);
                    // Fallback to dummy if for some reason it's missing (shouldn't happen if setup is correct)
                }

            } else {
                console.log("Please enter valid dimensions.");
                return;
            }
        }

        // Extract Size Name from Variant Options
        // We know Type and Color, the remaining option is Size
        let sizeName = '';
        if (variant) {
            variant.options.forEach(opt => {
                if (opt !== color && !opt.includes(type)) {
                    sizeName = opt;
                }
            });
            // Refined extraction: Map known indices
            if (this.optionMap && this.optionMap.size) {
                const idx = parseInt(this.optionMap.size.replace('option', '')) - 1;
                if (variant.options[idx]) sizeName = variant.options[idx];
            }
        } else {
            sizeName = "Custom";
        }

        // Check for Update vs Add
        if (this.editingIndex !== null && this.editingIndex >= 0) {
            // Update existing item
            this.bundleItems[this.editingIndex] = {
                id: itemId,
                title: itemTitle,
                price: itemPrice,
                comparePrice: itemComparePrice, // Added
                sku: itemSku,
                quantity: quantity,
                isCustom: isCustom, // Flag for custom filtering
                details: {
                    dims: `${parseFloat(length.toFixed(2))}×${parseFloat(width.toFixed(2))}×${parseFloat(height.toFixed(2))}"`,
                    color: color,
                    type: type,
                    size: sizeName
                }
            };
            this.editingIndex = null; // Reset editing state
            const addBtn = this.container.querySelector('[data-action="add-cushion"]');
            if (addBtn) addBtn.textContent = 'Add Cushion'; // Reset button text
        } else {
            // Add New Item (Always separate, no merging)
            // User Request: "show last added item to the top" -> unshift
            this.bundleItems.unshift({
                id: itemId,
                title: itemTitle,
                price: itemPrice,
                comparePrice: itemComparePrice, // Added
                sku: itemSku,
                quantity: quantity,
                isCustom: isCustom, // Flag for custom filtering
                details: {
                    dims: `${parseFloat(length.toFixed(2))}×${parseFloat(width.toFixed(2))}×${parseFloat(height.toFixed(2))}"`,
                    color: color,
                    type: type,
                    size: sizeName
                }
            });
        }

        this.saveBundle();
        this.renderBundleList();

        // Reset Fields
        this.container.querySelector('#dim-length').value = '';
        this.container.querySelector('#dim-width').value = '';
        this.container.querySelector('#dim-height').value = '';
        this.container.querySelector('#cushion-qty').value = '1'; // Reset Qty
        this.currentSelection.length = 0;
        this.currentSelection.width = 0;
        this.currentSelection.height = 0;
        this.currentSelection.quantity = 1; // Reset State
        // Reset Detected Display
        const displayEl = this.container.querySelector('#detected-type-display');
        if (displayEl) {
            displayEl.textContent = '';
            displayEl.style.display = 'none';
        }

        // Disable Add Button on Reset
        const addBtn = this.container.querySelector('[data-action="add-cushion"]');
        if (addBtn) addBtn.disabled = true;

        // Hide form steps (Mode 2: Summary View)
        // Hide form steps (Mode 2: Summary View)
        // User Request: "After clicking 'Add cushion' it'll open the next step for 'Bundle card' (Step 3)"
        this.goToStep(3);

        // User Request: "no longer need the scroll system here"
        // (Removed scroll logic)
    }

    saveBundle() {
        localStorage.setItem('couchBundleItems', JSON.stringify(this.bundleItems));
    }

    removeBundleItem(index) {
        this.bundleItems.splice(index, 1);
        this.saveBundle();
        this.renderBundleList();

        if (this.bundleItems.length === 0) {
            // User Request: "when we clear the Bundle card, it should not take us to the first step"
            // this.goToStep(0); 
        }
    }

    renderBundleList() {
        const listContainer = this.container.querySelector('#bundle-items-container');
        let total = 0;
        let totalCompareAt = 0; // Track Total Compare At

        // Empty State Logic
        const emptyState = this.container.querySelector('#bundle-empty-state');
        const summaryFooter = this.container.querySelector('.bundle-summary-footer');

        if (this.bundleItems.length === 0) {
            if (emptyState) emptyState.classList.remove('hidden');
            if (summaryFooter) summaryFooter.classList.add('hidden');
        } else {
            if (emptyState) emptyState.classList.add('hidden');
            if (summaryFooter) summaryFooter.classList.remove('hidden');
        }

        listContainer.innerHTML = this.bundleItems.map((item, idx) => {
            const lineTotal = item.price * item.quantity;
            total += lineTotal;

            // Calculate Compare At Total
            const itemComparePrice = (item.comparePrice && item.comparePrice > item.price) ? item.comparePrice : item.price;
            totalCompareAt += (itemComparePrice * item.quantity);


            // Resolve image based on type (fuzzy match or direct)
            let imgSrc = '';

            // normalize `type` (handle undefined and arrays)
            let type = '';
            if (item?.details) {
                if (Array.isArray(item.details.type)) {
                    type = item.details.type.join(' ');
                } else {
                    type = item.details.type ?? '';
                }
            }

            // ensure typeImages is an object
            const images = (this.typeImages && typeof this.typeImages === 'object') ? this.typeImages : {};

            // find key (case-insensitive)
            const typeKey = Object.keys(images).find(k =>
                typeof type === 'string' && type.toLowerCase().includes(String(k).toLowerCase())
            );

            if (typeKey) imgSrc = images[typeKey];

            // fallback image (optional: provide your own fallback path or property)
            const fallback = this.defaultImage || 'https://cdn.shopify.com/s/files/1/0471/7078/1350/files/seat_cover_icon_be0b408b-c8fe-4a58-adab-68e9cc4e02a6.jpg?v=1765779254';
            const imgTag = `<img src="${imgSrc || fallback}" class="bundle-item-img" alt="${(type || 'item')}" loading="lazy" width="60" height="60">`;

            // Subtitle Logic
            let subtitle = '';
            if (item.isCustom) {
                // User Request: "instead of 'Custom Request(Not Available)' to 'Custom Request'"
                subtitle = `<span>Custom Request</span>`;
            } else {
                // User Request: "The title should like this: Chaise Cushion (M)"
                // We stored these in details separately.
                if (item.details.type && item.details.size) {
                    subtitle = `${item.details.type} (${item.details.size})`;
                } else {
                    // Fallback to title if details missing
                    subtitle = item.title;
                }
            }

            // Price Logic (with Compare At)
            const priceDisplay = `$${(lineTotal / 100).toFixed(2)}`;
            let compareDisplay = '';

            // Calculate total compare at price for line item
            if (item.comparePrice && item.comparePrice > item.price) {
                const lineCompareTotal = item.comparePrice * item.quantity;
                compareDisplay = `<span style="text-decoration: line-through; color: #999; font-size: 13px;">$${(lineCompareTotal / 100).toFixed(2)}</span>`;
            }

            // Unit Price Logic for Details (Under Color)
            let unitPriceDisplay = '';
            if (item.comparePrice && item.comparePrice > item.price) {
                unitPriceDisplay = `
                   <div style="font-size: 11px; margin-top: 2px;">
                      <span style="text-decoration: line-through; color: #999;">$${(item.comparePrice / 100).toFixed(2)}</span>
                      <span style="font-weight: 500; color: #555a60;">$${(item.price / 100).toFixed(2)}</span>
                   </div>
                 `;
            } else {
                unitPriceDisplay = `
                   <div style="font-size: 11px; margin-top: 2px;">
                      <span style="font-weight: 500;color:#555a60;">$${(item.price / 100).toFixed(2)} each</span>
                   </div>
                 `;
            }


            return `
              <div class="bundle-item">
                <div class="bundle-item-image">
                    ${imgTag}
                </div>
                <div class="bundle-item-details">
                   <div class="bundle-item-title">${subtitle}</div>
                   <div class="bundle-item-meta">
                     <span style="color: #555a60;">${item.details.dims}, ${item.details.color}</span><br>
                     <span>${unitPriceDisplay}</span>
                   </div>
                   <div class="bundle-item-qty"><span>Qty: ${item.quantity}</span></div>
                </div>
                <div class="bundle-item-col-actions">
                <button type="button" class="btn-remove-item" data-index="${idx}" title="Remove">x</button>
                   <div class="bundle-item-price">
                    <span>${priceDisplay}</span>
                    <span>${compareDisplay}</span>
                   </div>
                   <button type="button" class="btn-edit-item" data-index="${idx}">Edit</button>
                </div>
              </div>
            `;
        }).join('');

        const bundleContainer = this.container.querySelector('#bundle-items-container');
        if (bundleContainer) {
            // Re-bind listeners (using event delegation is cleaner, but ensuring strict order)
            // Or just rely on the existing delegation block in bindEvents if present?
            // The previous code had a specific listener block inside init/bindEvents, 
            // but we need to ensure actions are handled.
            // Let's assume global delegation in bindEvents or add specific logic here?
            // Actually, best to delegate in bindEvents. Let's make sure bindEvents handles it.
        }

        // --- SUBTOTAL UPDATE ---
        this.container.querySelector('.subtotal-price').textContent = `$${(total / 100).toFixed(2)}`;
        this.container.querySelector('.subtotal-row').style.display = total > 0 ? 'flex' : 'none';

        // --- SUBOTAL COMPARE AT UPDATE ---
        const subtotalCompareEl = this.container.querySelector('.subtotal-compare-at');
        if (subtotalCompareEl) {
            if (totalCompareAt > total) {
                subtotalCompareEl.textContent = `$${(totalCompareAt / 100).toFixed(2)}`;
                subtotalCompareEl.classList.remove('hidden');
            } else {
                subtotalCompareEl.classList.add('hidden');
            }
        }

        // --- SHIPPING INFO UPDATE ---
        const shippingInfoEl = this.container.querySelector('.shipping-info');
        const shippingValEl = this.container.querySelector('.shipping-value');
        if (shippingInfoEl && shippingValEl) {
            if (total > 0) {
                shippingInfoEl.classList.remove('hidden');
                if (total >= 10000) { // $100.00 (in cents)
                    shippingValEl.textContent = "FREE";
                    shippingValEl.style.fontWeight = "bold"; // Optional: Make "FREE" stand out
                    shippingValEl.style.color = "#4CAF50"; // Optional: Green for free
                } else {
                    shippingValEl.textContent = "$4.95";
                    shippingValEl.style.fontWeight = "normal";
                    shippingValEl.style.color = "#555";
                }
            } else {
                shippingInfoEl.classList.add('hidden');
            }
        }
    }

    editBundleItem(index) {
        const item = this.bundleItems[index];
        if (!item) return;

        this.editingIndex = index; // Set Editing Index

        // Parse Dimensions
        // Format: "25×30×2.72""
        const dims = item.details.dims.replace('"', '').split('×');
        if (dims.length === 3) {
            this.currentSelection.length = parseFloat(dims[0]);
            this.currentSelection.width = parseFloat(dims[1]);
            this.currentSelection.height = parseFloat(dims[2]);

            // Populate Inputs
            this.container.querySelector('#dim-length').value = dims[0];
            this.container.querySelector('#dim-width').value = dims[1];
            this.container.querySelector('#dim-height').value = dims[2];
        }

        // Populate Color
        // We need to check the radio button for this color
        this.currentSelection.color = item.details.color;
        // Sync UI (Visuals, Redio, Preview Text)
        this.syncColorFromDefault(item.details.color);

        // Populate Quantity
        this.currentSelection.quantity = item.quantity;
        const qtyInput = this.container.querySelector('#cushion-qty');
        if (qtyInput) qtyInput.value = item.quantity;

        // Trigger Auto-Detection so Type display updates
        this.detectAndDisplayType();

        // Change "Add Cushion" button text to "Update Cushion"
        const addBtn = this.container.querySelector('[data-action="add-cushion"]');
        if (addBtn) addBtn.textContent = 'Update Cushion';

        // Go to Step 2 (No Scroll)
        this.goToStep(2);
        // User Request: "Remove the all scroll when we do any action"
        // const step2 = this.container.querySelector('[data-step="2"]');
        // if (step2) step2.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    addBundleToCart() {
        if (this.bundleItems.length === 0) return;

        // Button Loading State
        const btn = this.container.querySelector('[data-action="add-bundle-to-cart"]');
        const originalText = btn ? btn.textContent : 'Add Bundle to Cart';
        if (btn) {
            btn.disabled = true;
            btn.textContent = 'Adding Bundle...';
        }

        const cartItems = [];
        // User Request: "I like to save all data(Available sizes or Custom) in google sheet."
        // So sheetItems is a copy of everything.
        const sheetItems = [...this.bundleItems];

        this.bundleItems.forEach(item => {
            // "only the available items will added to the cart"
            // User Update: "So, we also add this [custom] item in the cart."
            // So we REMOVE the !item.isCustom check. ALL items go to cart.
            cartItems.push({
                id: item.id,
                quantity: item.quantity,
                // Optional: We could pass properties for custom dims if Shopify supports line item props
                properties: item.isCustom ? {
                    "Custom Request": "Yes",
                    "Dimensions": item.details.dims
                } : {}
            });
        });

        // Promise chain to handle both
        let cartPromise = Promise.resolve();

        if (cartItems.length > 0) {
            const cartUrl = window.routes ? window.routes.cart_add_url : '/cart/add.js';
            cartPromise = fetch(cartUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: cartItems })
            }).then(r => r.json());
        }

        cartPromise
            .then(data => {
                // Submit ALL items to Google Sheet
                if (sheetItems.length > 0) {
                    console.log("Submitting All Items to Google Sheet...", sheetItems);
                    // If we have cart items, we want to be silent (no alert), just background sync.
                    const isSilent = cartItems.length > 0;
                    this.submitToGoogleSheet(sheetItems, isSilent);
                }

                // Reset button state if handled here (mostly for cart success flow)
                if (btn) {
                    btn.disabled = false;
                    btn.textContent = originalText;
                }

                // If we added real items, show cart
                if (cartItems.length > 0) {
                    this.showFinalCartDrawer();
                }
                // If only custom items (no cart items), submitToGoogleSheet will handle alert & reset.
            })
            .catch((error) => {
                console.error('Error:', error);
                if (btn) {
                    btn.disabled = false;
                    btn.textContent = originalText;
                }
            });
    }

    submitToGoogleSheet(items, silent = false) {
        // User provided Web App URL (No Login Required)
        const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycby-gABcW_Q99SEtcxrtBE-lZIhrSLEKUW1jJSIb_t4slncwrqnq8_OHJd0k-J8BGgwi/exec';

        // Get Product Context
        const container = document.querySelector('.product-variant-picker-steps');
        const productTitle = container ? container.dataset.productTitle : document.title;
        const productUrl = window.location.href;

        // Get or Create Persistent Customer ID
        const customerId = this.getOrCreateUUID();

        const rows = items.map(item => [
            customerId,                  // Customer ID (First Column)
            new Date().toLocaleString(), // Date
            item.sku || "CUSTOM-REQ",    // SKU
            productTitle,                // Product Title
            productUrl,                  // URL
            item.details.dims,           // Dims
            item.details.color,          // Color
            item.details.type || "",     // Type (New)
            item.details.size || "",     // Size (New)
            item.quantity,               // Qty
            "Pending"                    // Status
        ]);

        // Use fetch with text/plain to avoid CORS Preflight (OPTIONS) issues with Google Apps Script
        fetch(SCRIPT_URL, {
            method: 'POST',
            body: JSON.stringify(rows)
        })
            .then(response => {
                console.log("Sheet Updated");
                if (!silent) {
                    console.log("Your custom request has been submitted! We will contact you shortly.");
                }

                // Clear bundle - DISABLED per user request
                // this.bundleItems = [];
                // this.saveBundle();
                // this.renderBundleList();
                // this.goToStep(0); // Reset UI to start
            })
            .catch(error => {
                console.error('Error submitting to sheet:', error);
                if (!silent) {
                    console.log("There was an issue submitting your request, but we have noted it locally. Please contact support if issues persist.");
                }
            });
    }

    getOrCreateUUID() {
        let uuid = localStorage.getItem('variant_picker_uuid');
        if (!uuid) {
            // Simple UUID generator
            uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
            localStorage.setItem('variant_picker_uuid', uuid);
        }
        return uuid;
    }

    showFinalCartDrawer() {
        try {
            fetch(`${routes.cart_url}?sections=cart-icon-bubble,cart-drawer`)
                .then((response) => response.json()) // Parse response as JSON
                .then((data) => {
                    // fetch cart before update drawer
                    this.fetchShopifyCart().then(cart => {
                        if (cart) {
                            Debutify.cart.total_price = cart.total_price;
                            console.log('Total: ', Debutify.cart.total_price);
                        }
                    });
                    // Update cart-icon-bubble section
                    const bubbleSectionHtml = data['cart-icon-bubble'];
                    if (bubbleSectionHtml) {
                        const bubbleParser = new DOMParser().parseFromString(bubbleSectionHtml, 'text/html');
                        const newBubbleSection = bubbleParser.querySelector('cart-bubble');
                        const existingBubbleContainer = document.querySelector('cart-bubble');
                        if (newBubbleSection && existingBubbleContainer) {
                            existingBubbleContainer.replaceWith(newBubbleSection);
                        }
                    }

                    // Update cart-drawer section
                    const drawerSectionHtml = data['cart-drawer'];
                    if (drawerSectionHtml) {
                        const drawerParser = new DOMParser().parseFromString(drawerSectionHtml, 'text/html');
                        const existingCartDrawer = document.querySelector('cart-drawer');
                        const newCartDrawer = drawerParser.querySelector('cart-drawer');
                        if (newCartDrawer && existingCartDrawer) {
                            existingCartDrawer.replaceWith(newCartDrawer);
                        }
                        const cartGoal = document.querySelector('.product__info-wrapper dtc-goals-bar');
                        const newGoal = newCartDrawer.querySelector('dtc-goals-bar');
                        if (cartGoal && newGoal) {
                            cartGoal.innerHTML = newGoal.innerHTML;

                        }
                    }
                })
                .then(() => {
                    const cartDrawerElement = document.querySelector('cart-drawer');
                    if (cartDrawerElement) {
                        cartDrawerElement.classList.remove('is-empty');
                        Debutify.showCartDrawer();
                        document.body.classList.add("overflow-hidden");
                    }
                })
                .catch((e) => {
                    console.error(e);
                });
        } catch (error) {
            console.error("Error adding to cart:", error);
        }

    }

    async fetchShopifyCart() {
        try {
            const response = await fetch('/cart.js', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const cartData = await response.json();

            return cartData;
        } catch (error) {
            console.error('Error fetching Shopify cart:', error);
            return null;
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('.product-variant-picker-steps');
    if (container) {
        new VariantPickerSteps(container);
    }
});
